export interface SessionsHrefParams {
  // A single workflow slug or a list of slugs (serialized as a CSV the sessions
  // list parses back into a slug filter).
  slug?: string | string[]
  dutyId?: string
}

// Build a deep-link to the sessions list. AllSessionsListView restores these
// filters from the URL (slug CSV / duty_id) plus the default newest-first sort.
// Centralized so callers (workflow list card, duty canvas) share one contract
// and can't drift if the query params change. Prefers slug over duty_id.
export function sessionsHref({
  slug,
  dutyId,
}: SessionsHrefParams = {}): string {
  const search = new URLSearchParams({
    sort_by: 'created_at',
    sort_order: 'desc',
  })

  const slugValue = Array.isArray(slug) ? slug.join(',') : slug
  if (slugValue) {
    search.set('slug', slugValue)
  } else if (dutyId) {
    search.set('duty_id', dutyId)
  }

  return `/sessions?${search.toString()}`
}
